import store from "~/js/store/store";
export default class Color {
  constructor() {
    this.contents = document.querySelector('._color');
    this.select = this.contents.querySelector('._select');
    this.inputs = this.contents.getElementsByTagName("input");
    this.more = this.contents.querySelector('._more');
    this.close = this.contents.querySelector('._close');
    this.firstText = this.contents.querySelector('.first_text')

    this.isOpen = false;

    if(document.getElementsByName("color").length<=8)
    {
      this.contents.classList.add("off");
      this.isOpen = true;
    }
    else
    {
      this.contents.classList.add("close");
    }

    this.setup()

    //フォーカスを操作
    document.addEventListener('keydown', function(event)
    {
      var tabKey = (9 === event.keyCode);
      var enterKey = (13 === event.keyCode);
      var shiftKey = event.shiftKey;
      if(tabKey || enterKey)
      {
        for(var i = 0; i <  this.inputs.length; i++)
        {
          if(this.inputs[i]==document.activeElement)
          {
            var _num = i;
            if(tabKey)
            {
              if(shiftKey)
              {
                if(_num!=0)
                {
                  setTimeout(function()
                  {
                    this.inputs[_num-1].focus();
                  }.bind(this), 0.1);
                }
              }
              else
              {
                if(this.isOpen)
                {
                  if(this.inputs.length!=_num)
                  {
                    setTimeout(function()
                    {
                      this.inputs[_num+1].focus();
                    }.bind(this), 0.1);
                  }
                }
                else
                {
                  if(6!=_num)
                  {
                    setTimeout(function()
                    {
                      this.inputs[_num+1].focus();
                    }.bind(this), 0.1);
                  }
                }
              }
            }
            else if(enterKey)
            {
              this.inputs[_num].click();
            }
          }
        }
      }
    }.bind(this));
  }

  setup () {
		for(var i = 0; i <  this.inputs.length; i++)
    {
      this.inputs[i].addEventListener('click', (event) => {
        let target = event.currentTarget;
        this.select.textContent = target.dataset.id;
        this.firstText.style.display = 'none'

        store.dispatch('setColorNum', {
          num: target.dataset.num
        });

        if(target.dataset.photo)
        {
          document.getElementById(target.dataset.photo).click();
        }
      })
    }

    //一つ目のカラーを選択
    //this.inputs[0].click();

    this.more.addEventListener('click', (event) => {
      this.isOpen = true;
      this.contents.classList.remove("close");
      if(document.getElementsByName("color").length%4==0)
      {
        this.contents.classList.add("long");
      }
      setTimeout(function()
      {
        this.inputs[7].focus();
      }.bind(this), 0.1);
    });
    this.close.addEventListener('click', (event) => {
      this.isOpen = false;
      this.contents.classList.add("close");
      this.contents.classList.remove("long");
    });
  }

}